import React from 'react';
import { Row } from 'react-bootstrap';

import EditableField from 'components/add_order/order/OrderDetail/OrderShipments/EditableField';

import {
  BEFORE_PACKED_SHIPMENT_STATUSES,
  PACKED_SHIPMENT_STATUSES,
} from 'constants/shipment';
import { TIME_OPTION } from 'constants/time';

const OrderShipmentFieldList = ({
  shipment,
  isEditing,
  formData,
  handleChange,
  shippingProviders,
}) => {
  const canEditBeforePacked = BEFORE_PACKED_SHIPMENT_STATUSES.includes(
    shipment.shipment_status,
  );

  const canEditPacked = PACKED_SHIPMENT_STATUSES.includes(
    shipment.shipment_status,
  );

  const canEdit = canEditBeforePacked || canEditPacked;

  // shipment status에 따라 수정 가능한 필드 정의
  const isEditable = field => {
    if (!canEdit) return false;

    if (canEditBeforePacked) {
      return [
        'package_width',
        'package_length',
        'package_height',
        'weight',
      ].includes(field);
    }

    if (canEditPacked) {
      return [
        'package_width',
        'package_length',
        'package_height',
        'weight',
        'awb_number',
        'invoice_code',
        'shipping_provider',
      ].includes(field);
    }

    return false;
  };

  const handleWeightChange = e => {
    handleChange({
      target: {
        name: 'weight',
        value: {
          ...formData.weight,
          value: e.target.value,
          unit: formData?.weight?.unit,
        },
      },
    });
  };

  const handleShippingProviderChange = e => {
    const selectedProvider = shippingProviders.find(
      provider => provider.id === Number(e.target.value),
    );

    handleChange({
      target: {
        name: 'shipping_provider',
        value: selectedProvider ? selectedProvider : null,
      },
    });
  };

  return (
    <Row>
      <EditableField
        label="Picklist Number"
        value={shipment.picklist?.picklist_code}
        isEditing={isEditing}
        isEditable={false}
      />
      <EditableField
        label="Shipment Manifest"
        value={shipment.manifest?.manifest_code}
        isEditing={isEditing}
        isEditable={false}
      />
      <EditableField
        label="Return Manifest"
        value={shipment.return_manifest?.return_manifest_code}
        isEditing={isEditing}
        isEditable={false}
      />

      <EditableField
        label="Invoice Code"
        value={shipment.invoice_code}
        isEditing={isEditing}
        isEditable={isEditable('invoice_code')}
        name="invoice_code"
        onChange={handleChange}
      />
      <EditableField
        label="AWB No."
        value={formData.awb_number}
        isEditing={isEditing}
        isEditable={isEditable('awb_number')}
        name="awb_number"
        onChange={handleChange}
      />
      <EditableField
        label="Shipping Provider"
        value={formData?.shipping_provider}
        isEditing={isEditing}
        isEditable={isEditable('shipping_provider')}
        name="shipping_provider"
        type="select"
        options={shippingProviders.map(provider => ({
          value: provider.id,
          label: provider.shipping_provider_type,
        }))}
        displayField="shipping_provider_type"
        onChange={handleShippingProviderChange}
      />

      <EditableField
        label="Parent Package"
        value={shipment.parent_shipment?.shipment_code}
        isEditing={isEditing}
        isEditable={false}
      />
      <EditableField
        label="Dispatched Date"
        value={
          shipment.dispatched_date
            ? new Date(shipment.dispatched_date).toLocaleString(
                'en-IN',
                TIME_OPTION,
              )
            : ''
        }
        isEditing={isEditing}
        isEditable={false}
      />
      <EditableField
        label="Delivery Date"
        value={
          shipment.delivery_date
            ? new Date(shipment.delivery_date).toLocaleString(
                'en-IN',
                TIME_OPTION,
              )
            : ''
        }
        isEditing={isEditing}
        isEditable={false}
      />

      <EditableField
        label="Package Width (mm)"
        value={
          isEditing
            ? formData.package_width
            : Number(formData.package_width).toFixed(2)
        }
        isEditing={isEditing}
        isEditable={isEditable('package_width')}
        name="package_width"
        onChange={handleChange}
      />
      <EditableField
        label="Package Length (mm)"
        value={
          isEditing
            ? formData.package_length
            : Number(formData.package_length).toFixed(2)
        }
        isEditing={isEditing}
        isEditable={isEditable('package_length')}
        name="package_length"
        onChange={handleChange}
      />
      <EditableField
        label="Package Height (mm)"
        value={
          isEditing
            ? formData.package_height
            : Number(formData.package_height).toFixed(2)
        }
        isEditing={isEditing}
        isEditable={isEditable('package_height')}
        name="package_height"
        onChange={handleChange}
      />

      <EditableField
        label={`Weight (${formData.weight?.unit})`}
        value={formData.weight?.value}
        isEditing={isEditing}
        isEditable={isEditable('weight')}
        name="weight.value"
        onChange={handleWeightChange}
      />
      <EditableField
        label="No. of Items"
        value={shipment.total_quantity || 0}
        isEditing={isEditing}
        isEditable={false}
      />
    </Row>
  );
};

export default OrderShipmentFieldList;
